import React, { useEffect, useMemo, useState } from 'react';
import Dialog from '../Dialog/Dialog';
import { translate } from '../../Services/translation';
import { get } from '../../Services/http';
import { EditorStringModel } from '../../Types/EditorString';
import EditorString from '../EditorString/EditorString';
import { INVOICE_DEBT_ACKNOWLEDGE } from '../../constants'

type UnpaidInvoice = {
  amountDue: number,
  customerNo: string,
}
type UnpaidInvoiceData = {
  formattedTotalBalance: string,
  unpaidInvoices: UnpaidInvoice[],
}

const InvoiceModal = ({
  invoiceModalMessage,
  invoiceModalLink,
}: {
  invoiceModalMessage: EditorStringModel;
  invoiceModalLink?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [unpaidInvoiceData, setUnpaidInvoices] = useState<UnpaidInvoiceData | undefined>();
  const totalBalance = useMemo(() => unpaidInvoiceData?.unpaidInvoices.reduce((prev, curr) => prev + curr.amountDue, 0) ?? 0, [unpaidInvoiceData])

  const rootRoute = '/api/getunpaidinvoicesamount';

  const getUnpaidInvoiceInformation = async () => {
    return get(`${rootRoute}`)
      .then((response) => response.json())
      .then((result) => {
        setUnpaidInvoices(result);
      })
      .catch((ex) => {
        throw ex;
      })
  }

  useEffect(() => {
    if (sessionStorage.getItem(INVOICE_DEBT_ACKNOWLEDGE) === 'true') {
      return;
    }
    getUnpaidInvoiceInformation();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem(INVOICE_DEBT_ACKNOWLEDGE) === 'true') {
      return;
    }
    setIsOpen(totalBalance > 0)
  }, [totalBalance])

  const handleOnClose = () => {
    setIsOpen(false);
    sessionStorage.setItem(INVOICE_DEBT_ACKNOWLEDGE, 'true');
  };
  const handleButtonClick = () => {
    setIsOpen(false);
    sessionStorage.setItem(INVOICE_DEBT_ACKNOWLEDGE, 'true');
    if(!!invoiceModalLink) {
      location.assign(`${invoiceModalLink}#/invoices`);
    }
  };
  const headerContent = (
    <div>
      <h2 className="text-xl">{translate('invoice-modal.header')}</h2>
    </div>
  );

  return (
    <Dialog
      isOpen={isOpen}
      closeButtonAriaLabel="close"
      headerContent={headerContent}
      onClose={handleOnClose}
    >
      <div className="flex max-w-xl flex-col gap-8">
        <EditorString {...invoiceModalMessage} />
        <div className="rounded-lg border border-gray-100 px-4 shadow-lg">
          <div className="flex justify-between border-b border-gray-100 py-4 text-gray-700">
            <span className="text-sm">
              {translate('invoice-modal.customer-number')}
            </span>
            {unpaidInvoiceData && unpaidInvoiceData?.unpaidInvoices.length > 0 &&
              <span className="text-sm font-bold">{unpaidInvoiceData.unpaidInvoices[0]!.customerNo}</span>
            }
          </div>
          <div className="flex flex-col items-center justify-center gap-1 py-4">
            {translate('invoice-modal.unpaid-balance')}
            <span className="text-h2 font-bold text-red-500">
              {unpaidInvoiceData?.formattedTotalBalance}
            </span>
          </div>
        </div>
        <button
          className="btn btn--primary btn--large self-center"
          onClick={handleButtonClick}
        >
          {translate('invoice-modal.button-label')}
        </button>
      </div>
    </Dialog>
  );
};

export default InvoiceModal;
